import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h2>This is My treatmnt history</h2>
        </div>
    );
};

export default MyHistory;